<div
    [id]="id"
    *ngIf="entityInternal"
    class="agpr-targetingResults-cardWrapper agpr-contextMenu-parent"
    [ngClass]="{
        'agpr-targetingResults-cardWrapper-focused': selectedOutletId === entityInternal.id
    }"
>
    <div
        role="group"
        class="agpr-targetingResults-card card"
        (agprClickUnless)="onCardClicked(entityInternal)"
        [agprClickUnlessSelectors]="['a', 'agpr-checkbox']"
        [attr.aria-label]="'Discover.universal.outletCard.label' | localize: {name: entityInternal.name}"
        (keydown)="onKeydown($event)"
    >
        <div class="agpr-targetingResults-card-grid">
            <div class="agpr-targetingResults-card-left">
                <div class="agpr-targetingResults-card-checkbox">
                    <agpr-checkbox
                        [id]="id + '_selectedCheckbox'"
                        [value]="entityInternal"
                        [disabled]="disableSelection"
                        [hiddenLabel]="entityInternal.name"
                        [initiallyFocusable]="initiallyFocusable"
                        [(ngModel)]="selectedResults"
                        (onChange)="checkboxClick()"
                    ></agpr-checkbox>
                    <div
                        *ngIf="selectedOutletId === entityInternal.id"
                        class="agpr-targetingResults-card-selectedBar"
                    ></div>
                </div>

                <div class="agpr-targetingResults-card-thumbnail">
                    <img
                        class="agpr-targetingResults-card-thumbnail-img"
                        alt=""
                        [agprImageSrc]="entityInternal.avatarUrl | twitterAvatarSize:twitterAvatarSizes.bigger"
                        [agprDefaultImage]="imageDefault.SMALL_OUTLET"
                    />
                    <span
                        *ngIf="listMemberships.length > 0 && listMemberships.length === workingLists.length"
                        role="img"
                        class="fa-regular fa-duotone fa-check agpr-targetingResults-card-thumbnail-checkmark"
                        [agprTooltip]="listMembershipTooltip"
                        [escape]="false"
                        [initiallyFocusable]="initiallyFocusable"
                    ></span>
                    <span
                        *ngIf="listMemberships.length > 0 && listMemberships.length !== workingLists.length"
                        class="agpr-targetingResults-card-thumbnail-number"
                        [agprTooltip]="listMembershipTooltip"
                        [escape]="false"
                        [initiallyFocusable]="initiallyFocusable"
                    >
                        {{ listMemberships.length }}
                    </span>

                    @if(distMemberships.length > 0 && distMemberships.length === workingDists.length) {
                        <span
                            role="img"
                            class="fa-regular fa-duotone fa-check agpr-targetingResults-card-thumbnail-checkmark"
                            [agprTooltip]="distMembershipTooltip"
                            [escape]="false"
                            [initiallyFocusable]="initiallyFocusable"
                        ></span>
                    }
                    @if(distMemberships.length > 0 && distMemberships.length !== workingDists.length) {
                        <span
                            class="agpr-targetingResults-card-thumbnail-number"
                            [agprTooltip]="distMembershipTooltip"
                            [escape]="false"
                            [initiallyFocusable]="initiallyFocusable"
                        >
                            {{ distMemberships.length }}
                        </span>
                    }
                </div>

                <div class="agpr-targetingResults-card-description-container">
                    <div class="agpr-targetingResults-card-description">
                        <div class="agpr-targetingResults-card-description-profile">
                            <a
                                class="agpr-targetingResults-card-description-profile-name"
                                href="#outlet-profile"
                                [id]="entityInternal.id + '_outlet_profile'"
                                [agprTooltip]="'Discover.universal.outletLink.tooltip'"
                                tooltipPosition="top"
                                (click)="focusOutlet($event)"
                            >
                                {{ entityInternal.name | localize }}
                            </a>
                            <span
                                role="img"
                                class="fa-kit fa-agpr-outlet-solid agpr-targetingResults-card-description-profile-icon"
                                [attr.aria-label]="'Discover.universal.outletLinkIcon'"
                            ></span>
                        </div>
                        <div
                            *ngIf="entityInternal.mediaTypes && entityInternal.mediaTypes.length > 0"
                            class="agpr-targetingResults-card-description-mediaType"
                        >
                            <span
                                *ngFor="let mediaType of entityInternal.mediaTypes; let last = last"
                            >
                                {{ mediaType.displayString | localize }}{{ !last ? ', ' : ''}}
                            </span>
                        </div>
                        <div *ngIf="entityInternal.coverageFocus">{{entityInternal.coverageFocus.displayString}}</div>
                    </div>
                    <div class="agpr-targetingResults-card-details-badges">
                       @for(badge of entityInternal.badges; track badge.tooltip) {
                            <span
                                role="img"
                                class="agpr-targetingResults-card-badges {{badge.iconClass}}"
                                [agprTooltip]="badge?.tooltip"
                                [initiallyFocusable]="initiallyFocusable"
                            ></span>
                        }
                    </div>
                </div>
            </div>

            <div class="agpr-targetingResults-card-divider"></div>

            <div class="agpr-targetingResults-card-details-container agpr-targetingResults-card-right">
                <div class="agpr-targetingResults-card-details">
                    <div class="agpr-targetingResults-card-details-field">
                        <div
                            *ngIf="entityInternal.locationString"
                            class="agpr-targetingResults-card-details-location"
                        >
                            <agpr-meta-data
                                [id]="id"
                                [icon]="'fa-solid fa-location-dot'"
                                [value]="entityInternal.locationString"
                                [tooltip]="entityInternal.locationString"
                                [initiallyFocusable]="initiallyFocusable">
                            </agpr-meta-data>
                        </div>
                        <div
                            *ngIf="!entityInternal.locationString"
                            class="agpr-targetingResults-card-details-location"
                        >
                            <agpr-meta-data
                                [id]="id"
                                [icon]="'fa-solid fa-location-dot'"
                                [value]="'Discover.universal.unknownLocation'"
                                [tooltip]="'Mention.details.location'"
                                [initiallyFocusable]="initiallyFocusable">
                            </agpr-meta-data>
                        </div>
                    </div>
                    <div
                        class="agpr-targetingResults-card-details-field"
                        *ngIf="reachValue"
                    >
                        <agpr-meta-data
                            [id]="id"
                            [type]="attributeTypes.audienceReach"
                            [icon]="reachIcon"
                            [value]="reachValue"
                            [isSimilarWeb]="isReachValueFromSimilarWeb"
                            [tooltip]="reachUnit"
                            [initiallyFocusable]="initiallyFocusable"
                        ></agpr-meta-data>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="agpr-contextMenu bottom right">
        <ng-container *ngIf="contextMenuTemplate">
            <ng-container
                *ngTemplateOutlet="
                    contextMenuTemplate;
                    context: {
                        className: 'agpr-targetingResults-cardWrapper-contextMenu-button',
                        selectedResult: entityInternal
                    }"
            ></ng-container>
        </ng-container>
        @if (addToType === targetingAddToTypes.LIST) {
            <agpr-button
                [id]="id + '.manageList'"
                class="agpr-targetingResults-cardWrapper-contextMenu-button"
                [style]="buttonTypes.contextMenu"
                [icon]="'fa-regular fa-duotone fa-gear'"
                tooltip="Discover.targeting.actions.manageLists"
                [initiallyFocusable]="initiallyFocusable"
                (click)="openManageListDialog(entityInternal)"
            ></agpr-button>
        }
        @if (addToType === targetingAddToTypes.DISTRIBUTION) {
            <agpr-button
                [id]="id + '.manageDist'"
                class="agpr-targetingResults-cardWrapper-contextMenu-button"
                [style]="buttonTypes.contextMenu"
                [icon]="'fa-regular fa-duotone fa-gear'"
                tooltip="Discover.targeting.actions.manageDists"
                [initiallyFocusable]="initiallyFocusable"
                (click)="openManageDistDialog(entityInternal)"
            ></agpr-button>
        }
    </div>
</div>
